import Vue from 'vue'
import store from '@/store/index'
import router from '@/router'


import axios from 'axios'
axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = 'X-CSRFToken'




import VueRaven from 'vue-raven'

import App from '@/App.vue'
import './registerServiceWorker'
import BootstrapVue from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faGift, faCandyCane, faCalendarAlt, faAngleDoubleRight, faAngleDoubleDown, faEdit, faTrash, faPlusCircle, faHandPointLeft, faHandPointRight} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueMarkdown from 'vue-markdown'
import VueScrollTo from 'vue-scrollto'

library.add([faGift, faCandyCane, faCalendarAlt, faAngleDoubleRight, faAngleDoubleDown, faEdit, faTrash, faPlusCircle, faHandPointLeft, faHandPointRight]);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('vue-markdown', VueMarkdown);
Vue.config.productionTip = false

Vue.use(VueScrollTo)
Vue.use(BootstrapVue);
// Sentry for logging frontend errors
Vue.use(VueRaven, {
  dsn: process.env.VUE_APP_SENTRY_PUBLIC_DSN,
  disableReport: process.env.NODE_ENV === 'development'
})


new Vue({
  router,
  store,
  
  render: h => h(App)
}).$mount('#app')
